import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { getValueByPath } from '@shared/utils/get-value-by-path.util';

export function requiredKeys(keysToBeChecked: string[]|(() => string[])): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value) {
        const keys = Array.isArray(keysToBeChecked) ? keysToBeChecked : keysToBeChecked();
        let exist = false;
        keys.some((name) => {
          if (!getValueByPath(control.value, name)) {
            exist = true;
            return exist;
          }
        });

        if (exist) {
          return {
            isRequired: true,
          };
        }
        return null;
      }
    };
  }
